import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d8efc1d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "background-color": "white",
    "padding": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商铺管理", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_ShopCreateForm = _resolveComponent("ShopCreateForm");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": "1",
      ref: "shopList",
      onAddMore: _cache[0] || (_cache[0] = $event => $data.createVisible = true),
      onOnDetailData: $options.onDetailClick
    }, {
      state: _withCtx(data => [_createTextVNode(_toDisplayString(data.mapping[data.rowData]), 1)]),
      _: 1
    }, 8, ["onOnDetailData"])]),
    _: 1
  })]), _createVNode(_component_DialogCustomView, {
    title: "新增商铺",
    "visible-control": $data.createVisible,
    width: "60%",
    onClose: _cache[2] || (_cache[2] = $event => $data.createVisible = false)
  }, {
    dialog: _withCtx(() => [_createVNode(_component_ShopCreateForm, {
      onCancel: _cache[1] || (_cache[1] = $event => {
        $data.createVisible = false;
      }),
      onSave: $options.createShop
    }, null, 8, ["onSave"])]),
    _: 1
  }, 8, ["visible-control"])], 64);
}